export default __webpack_public_path__ + "static/media/may.aa26b221.mp4";